<template>
  <div class="app-bill-settings-wrapper" ref="wrapper">
    <SimonModal
      :is-visible="showUnsavedChangesModal"
      @hide="revertChanges"
      id="unsaved-changed-modal"
      show-footer-buttons
      :btn-left-title="modalCancleTitle"
      :btn-right-title="modalOkTitle"
      @btnRight="saveViaModal"
      @btnLeft="revertChanges"
    >
      <template v-slot:modalTitle>
        <h1><slot name="btnDismissUnsavedChangesModal"></slot></h1>
      </template>
      <slot name="txtUnsavedChangesModal"></slot>
    </SimonModal>
    <div class="bills-settings-selector">
      <slot name="txtBeforeSelect"></slot>
      <b-form>
        <b-form-group>
          <b-form-radio-group name="billsSettingsSelection">
            <b-form-radio id="billsSettingsSelection_online" v-model="selectedSetting" value="ONLINE_PORTAL" class="allBillsSelection">
              <div class="setting-row">
                <slot name="billsSettingSMS" class="bills-setting-SMS"></slot>
              </div>
            </b-form-radio>
            <b-form-radio id="billsSettingsSelection_email" v-model="selectedSetting" value="EMAIL" :disabled="emailNotVerified" class="allBillsSelection">
              <div class="setting-row">
                <EMailConfirmationMissing :inline-layout="true">
                  <template v-for="slot in possibleChildSlotsFor('ConfirmationMissing')" v-slot:[`${slot.child}`]>
                    <slot :name="`${slot.parent}`"></slot>
                  </template>
                </EMailConfirmationMissing>
              </div>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-form>
      <div class="btn-save-bills-settings">
        <button @click="saveSettings">
          <slot name="btnSaveSettings"></slot>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import preFilledInput from '@/mixins/preFilledInput'
import { mapActions } from 'vuex'
import transaction from '@/mixins/transaction'
import EMailConfirmationMissing
from '@/components/process/generic/ConfirmEmailVerification/EMailConfirmationMissing.vue'
import beErrors from '@/mixins/beErrors'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'ChangeBillsWrapper',
  components: { SimonModal, EMailConfirmationMissing },
  data () {
    return {
      currentCustomer: {
        emailVerified: false,
        invoiceChannel: ''
      },
      showUnsavedChangesModal: false,
      loadingNext: false,
      currentOrigin: '',
      eventListenerAdded: false

    }
  },
  computed: {
    preFilledSetting: function () {
      return this.currentCustomer.invoiceChannel
    },
    emailNotVerified: function () {
      return !this.currentCustomer.emailVerified
    },
    settingsChanged: function () {
      if (this.currentOrigin === '') {
        return this.currentCustomer.invoiceChannel !== this.selectedSetting
      } else {
        return this.currentOrigin !== this.selectedSetting
      }
    },
    modalOkTitle: function () {
      return this.$slots.btnSaveUnsavedChangesModal?.[0]?.text
    },
    modalCancleTitle: function () {
      return this.$slots.btnDismissUnsavedChangesModal?.[0]?.text
    }
  },
  watch: {
    selectedSetting: function () {
      this.addConfirmEventListener()
    }
  },
  methods: {
    ...mapActions('bills', [
      'changeInvoiceChannel'
    ]),
    saveSettings: function () {
      const comp = this
      return this.changeInvoiceChannel({ invoiceChannelType: this.selectedSetting }).then((result) => {
        if (result) {
          comp.currentOrigin = comp.selectedSetting
          comp.successToast(comp.$slots.txtToastSuccess ? comp.$slots.txtToastSuccess[0].text : 'Deine Rechnungseinstellung wurde erfolgreich gespeichert. Die Änderung tritt mit der nächsten Rechnung in Kraft.')
        } else {
          const errorMessage = comp.beErrorGetLastMessage()
          comp.errorToast(errorMessage)
        }
        return result
      })
    },
    addConfirmEventListener: function () {
      if (!this.eventListenerAdded) {
        window.addEventListener('beforeunload', this.handleUnload)
        window.addEventListener('pagehide', this.handleUnload)
        document.addEventListener('click', this.documentClick)
        this.eventListenerAdded = true
      }
    },
    handleUnload: function (e) {
      if (this.settingsChanged) {
        e.returnValue = 'Wenn sie diese Seite verlassen werden ihre Änderungen nicht gespeichert'
        return 'Wenn sie diese Seite verlassen werden ihre Änderungen nicht gespeichert'
      }
    },
    documentClick: function (e) {
      if (this.settingsChanged && !this.showUnsavedChangesModal && !this.loadingNext) {
        const el = this.$refs.wrapper
        if (el && el !== e.target && !el.contains(e.target)) {
          this.showUnsavedChangesModal = true
        }
      }
    },
    revertChanges: function () {
      this.showUnsavedChangesModal = false
      this.selectedSetting = this.currentCustomer.invoiceChannel
      this.currentOrigin = this.selectedSetting
    },
    saveViaModal: async function () {
      this.showUnsavedChangesModal = false
      this.loadingNext = true
      this.saveSettings().then(() => {
        this.loadingNext = false
      })
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query changeBills {
          currentCustomer {
            emailVerified
            invoiceChannel
          }
        }`, this, 'currentCustomer'
      )
    }
  },
  mixins: [
    preFilledInput('selectedSetting', 'preFilledSetting'),
    transaction('changeBills'),
    beErrors
  ]
}
</script>
